import React from 'react';

import { Box, Typography } from '@mui/material';
import LabelCDS from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS';
import {
  LabelSize,
  LabelVariant,
} from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS/LabelCDS.constants';

import { contextTextStyles, fieldCellStyles } from './SuppressedFields.styles';

export const config = {
  field: {
    label: 'Field',
    width: '32%',
    content: ({ fieldLabel, fieldContext }) => (
      <Box sx={fieldCellStyles}>
        <Typography data-truncated variant="medium14">
          {fieldLabel}
        </Typography>
        {!!fieldContext && (
          <Typography data-truncated sx={contextTextStyles} variant="regular12">
            {fieldContext}
          </Typography>
        )}
      </Box>
    ),
  },
  itemName: {
    label: 'Checklist Item',
    width: '32%',
    content: ({ itemName }) => (
      <Typography data-truncated variant="regular14">
        {itemName}
      </Typography>
    ),
  },
  suppressedBy: {
    label: 'Suppressed By',
    width: '20%',
    content: ({ actorName }) => (
      <LabelCDS size={LabelSize.S} title={actorName} variant={LabelVariant.ORANGE} />
    ),
  },
  overrideDateLabel: {
    label: 'When',
    width: '16%',
    content: ({ overrideDateLabel }) => (
      <Typography data-truncated variant="regular14">
        {overrideDateLabel}
      </Typography>
    ),
  },
};
